const familyValue = [
  { label: "Conservative", value: "Conservative" },
  { label: "Moderate", value: "Moderate" },
  { label: "Liberal", value: "Liberal" },
  { label: "Religious", value: "Religious" },
];
export default familyValue;
